import React from "react";
import { Box, Tooltip } from "@mui/material";
import HistoryIcon from "@mui/icons-material/Timeline";

export default function LogsIconDesign({
  size = 30,
  width = 50, // Increased default width
  color = "#4F46E5",
  onClick,
}) {
  return (
    <Tooltip title="Logs" arrow>
      <Box
        sx={{
          width: width, // Using the width prop instead of size for width
          height: size,
          backgroundColor: color,
          borderRadius: "4px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: onClick ? "pointer" : "default",
          "&:hover": {
            backgroundColor: "#fff",
            border: `2px solid ${color}`,
            "& .icon": {
              color: color,
            },
          },
        }}
        onClick={onClick}
      >
        <HistoryIcon
          className="icon"
          sx={{ color: "#fff", fontSize: size * 0.6 }}
        />
      </Box>
    </Tooltip>
  );
}
